import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoaderService} from './loader.service';
import {tap} from 'rxjs/operators';
import {InterceptorSkipHeader} from '../InterceptorSkipHeader';


@Injectable({
	providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {

	constructor(private loaderService: LoaderService) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		if (req.headers.has(InterceptorSkipHeader)) {
			const headers = req.headers.delete(InterceptorSkipHeader);
			return next.handle(req.clone({ headers }));
		}

		this.showLoader();

		return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
				if (event instanceof HttpResponse) {
					this.onEnd();
				}
			},
			(err: any) => {
				this.onEnd();
			}));
	}

	private onEnd(): void {
		this.hideLoader();
	}

	private showLoader(): void {
		this.loaderService.show();
	}

	private hideLoader(): void {
		this.loaderService.hide();
	}

}